module.exports = __webpack_public_path__ + "static/block-80b1a6d00090a067419989ee5e85eaf1.jpg";